// extracted by mini-css-extract-plugin
export default {"rubBalanceBlockPadding":"rubBalance_rubBalanceBlockPadding__LZkjk","rubBalanceText":"rubBalance_rubBalanceText__LI66F"};